<template>
  <div>
    <div
      v-for="(list, index) in menuContent"
      :key="`menu-${index}`"
    >
      <template v-for="(item, index) in list">
        <template v-if="item.linkActive">
          <template v-if="item.columns && item.columns.length">
            <transition
              :key="`list-${index}`"
              name="slide-fade"
            >
              <b-nav-item-dropdown
                :text="item.linkText"
                :key="index"
                :class="{ 'mega-menu': item.linkMegaMenu }"
                :title="item.linkTitle"
              >
                <li
                  v-for="(subItem, subIndex) in item.columns"
                  :key="`item-${subIndex}`"
                  class="nav-item floated"
                >
                  <template v-if="subItem.linkActive">
                    <div :key="subIndex">
                      <template v-if="subItem.columns">
                        <h3>{{ subItem.linkText }}</h3>
                        <ul>
                          <li
                            v-for="(subSubItem, subSubIndex) in subItem.columns"
                            :key="`subitem-${subSubIndex}`"
                            class="nav-item"
                          >
                            <template v-if="subSubItem.linkActive">
                              <div :key="subSubIndex">
                                {{ subSubItem.linkText }}
                              </div>
                            </template>
                          </li>
                        </ul>
                      </template>
                      <template v-else>
                        <ul>
                          <generic-link
                            :href="subItem.linkUrl"
                            :class="`single-link btn-${subItem.linkCallToAction}`"
                            :target="subItem.linkTarget"
                            :title="subItem.linkTitle"
                            tag="b-nav-item"
                          >
                            {{ subItem.linkText }}
                          </generic-link>
                        </ul>
                      </template>
                    </div>
                  </template>
                </li>
              </b-nav-item-dropdown>
            </transition>
          </template>
          <template v-else>
            <generic-link
              :key="`menu-${index}`"
              :href="item.linkUrl"
              :class="`btn-${item.linkCallToAction}`"
              :target="item.linkTarget"
              :title="item.linkTitle"
              tag="b-nav-item"
            >
              {{ item.linkText }}
            </generic-link>
          </template>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import GenericLink from '../../ui-elements/generic-link'

export default {
  components: {
    GenericLink
  },
  props: {
    menuContent: {
      type: Object,
      required: true
    }
  }
}
</script>
